// extracted by mini-css-extract-plugin
export var fadeInAnimation = "OfficesMap-module--fadeInAnimation--60a8e";
export var map = "OfficesMap-module--map--ddead";
export var mapWrapper = "OfficesMap-module--mapWrapper--036e8";
export var minusButton = "OfficesMap-module--minusButton--482ef";
export var plusButton = "OfficesMap-module--plusButton--b762d";
export var zoomButton = "OfficesMap-module--zoomButton--1bec7";
export var zoomControls = "OfficesMap-module--zoomControls--9297f";